import { EnvironmentType, ENVIRONMENT_TYPE } from '@curebase/core/lib/env';
import { AppTheme } from './AppTheme';
import curebaseTheme from './curebase';
import walgreensTheme from './walgreens';

export function getThemeBasedOnEnvironmentType(): AppTheme {
  if (ENVIRONMENT_TYPE === EnvironmentType.WALGREENS) return walgreensTheme;
  return curebaseTheme;
}
